<template>
    <div>
        <supa-base-header-sec class="mb-0"></supa-base-header-sec>
        <supa-advanced-search-base-header-sec></supa-advanced-search-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" v-on:keyup.enter="search" @reset="onReset">
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у називу</label>
                                <input id="titleQuery" v-model="titleQuery" type="text" class="form-control full-width">
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у тексту</label>
                                <input id="bodyQuery" v-model="bodyQuery" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Суд</label>
                                <select v-model="court" class="form-control full-width">
                                    <option value="-1">Сви судови</option>
                                    <option v-for="option in courts" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="departments.length > 0">
                                <label class="form-label">Судско одељење</label>
                                <select v-model="department" class="form-control full-width">
                                    <option value="-1">Сва одељења</option>
                                    <option v-for="option in departments" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Ознака и број акта </label>
                                <input v-model="actId" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Садржи</label>
                                <select v-model="contentType" class="form-control full-width">
                                    <option v-for="option in contentTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group v-if="contentSubtypes.length > 0" class="form-group-sm">
                                <label class="form-label">Подврста садржаја</label>
                                <select v-model="contentSubtype" class="form-control full-width">
                                    <option v-for="option in contentSubtypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                        </div>
                        <div class="col-md-4">

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Пропис битан за пресуђење</label>
                                <input v-model="essRule" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Чланови</label>
                                <input v-model="articles" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Релевантно право</label>
                                <input v-model="relLaw" type="text" class="form-control full-width">
                            </b-form-group>

                        </div>

                        <div class="col-md-4">

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна област</label>
                                <select v-model="legalAreaId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне области</option>
                                    <option v-for="option in legalAreas" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна материја</label>
                                <select v-model="legalSubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне материје</option>
                                    <option v-for="option in legalSubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="legalSubsubjects.length > 0">
                                <label class="form-label">Правна подматерија</label>
                                <select v-model="legalSubsubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне подматерије</option>
                                    <option v-for="option in legalSubsubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Начин објављивања</label>
                                <select v-model="publishingMethod" class="form-control full-width">
                                    <option value="-1" selected="selected">Све врсте објава</option>
                                    <option v-for="option in publishingMethods" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Books -->
                            <b-form-group class="form-group-sm" v-if="books.length > 0">
                                <label class="form-label">Производи/књига</label>
                                <select v-model="book" class="form-control full-width">
                                    <option value="-1" selected="selected">Све</option>
                                    <option v-for="option in books" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Biltens -->
                            <b-form-group class="form-group-sm" v-if="biltens.length > 0">
                                <label class="form-label">Назив билтена</label>
                                <select v-model="bilten" class="form-control full-width">
                                    <option value="-1" selected="selected">Све</option>
                                    <option v-for="option in biltens" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Sites -->
                            <b-form-group class="form-group-sm" v-if="sites.length > 0">
                                <label class="form-label">Адреса сајта</label>
                                <select v-model="site" class="form-control full-width">
                                    <option value="*" selected="selected">Све</option>
                                    <option v-for="option in sites" v-bind:key="option" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Issues -->
                            <div class="row" v-if="years.length > 0">
                                <b-form-group class="form-group-sm col-md-6">
                                    <label class="form-label">Година</label>
                                    <select v-model="year" class="form-control full-width">
                                        <option value="*" selected="selected">Све</option>
                                        <option v-for="option in years" v-bind:key="option" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                </b-form-group>

                                <b-form-group class="form-group-sm col-md-6">
                                    <label class="form-label">Број</label>
                                    <select v-model="issue" class="form-control full-width">
                                        <option value="*" selected="selected">Све</option>
                                        <option v-for="option in issues" v-bind:key="option.k" :value="option.k">
                                            {{ option }}
                                        </option>
                                    </select>
                                </b-form-group>
                            </div>

                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум од</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateFrom"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesFrom"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->
                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум до</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateTo"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesTo"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->

                            <data-picker-mask-component ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-component>

                        </div>
                    </div>

                    <div class="spacer20"></div>

                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="resultLimit" class="form-label mr-2">Величина резултата</label>
                                <select id="resultLimit" v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <b-button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search" v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="reset" class="btn btn-base-reset text-uppercase mr-3">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </b-button>
                            <b-button type="button" class="btn btn-base-reset text-uppercase" @click="copyQuery"
                                v-if="canCopyQuery" style="margin: 5px 0 0 0;">
                                <span class="icon-copy mr-2"></span>
                                Kopiraj upit
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>

            <result-counter :count="resultSize" :limit="limit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <!--                <sorted-table :values="result"-->
                <!--                              sort="timestamp"-->
                <!--                              dir="desc"-->
                <!--                              class="table table-striped table-sm table-slglrs"-->
                <!--                              ascIcon="<span> ▲</span>"-->
                <!--                              descIcon="<span> ▼</span>">-->
                <!--                    <thead>-->
                <!--                    <tr>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="courtName">Назив суда</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="subjectId">Ознака и број предмета</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="timestamp">Датум доношења</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="name">Ближе одређење материје / назив</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="issuer">Начин објављивања</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="issuePage">Број и страна</sort-link>-->
                <!--                        </th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <template #body="sort">-->
                <!--                        <tbody>-->
                <!--                        <tr v-for="(item, index) in sort.values" v-bind:key="index">-->
                <!--                            <td>{{item.courtName}}</td>-->
                <!--                            <td>{{item.subjectId}}</td>-->
                <!--                            <td>{{item.date}}</td>-->

                <!--                            <td><a :href="baseApiUrl + 'supa/viewAct/naziv-akta/' + item.htmlUuid" target="_blank">{{item.name}}</a></td>-->
                <!--                            <td>{{item.issuer}}</td>-->
                <!--                            <td>{{item.issuePage}}</td>-->
                <!--                        </tr>-->
                <!--                        </tbody>-->
                <!--                    </template>-->
                <!--                </sorted-table>-->

                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive="sm">
                    <template v-slot:cell(subjectId)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.subjectId
                        }}</router-link>
                    </template>
                    <template v-slot:cell(name)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.name
                        }}</router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SupaBaseHeaderSec from '@/base_pages/supa/SupaBaseHeaderSec.vue';
import SupaAdvancedSearchBaseHeaderSec from '@/base_pages/supa/SupaAdvancedSearchBaseHeaderSec.vue';
// import Datepicker from 'vuejs-datepicker';
// import {SortedTable, SortLink} from "vue-sorted-table";
import { srCYRL } from 'vuejs-datepicker/dist/locale'
import ResultCounter from '@/partials/ResultCounter.vue';

import DataPickerMaskComponent from '@/components/DataPickerMaskComponent.vue';
import { mapState } from 'vuex';


export default {
    name: "SupaAdvancedSearchFcSearchPage",
    data() {
        return {
            limit: 50,
            sortBy: 'timestamp',
            sortDesc: true,
            fields: [
                { label: 'Назив суда', key: 'courtName', sortable: true },
                { label: 'Ознака и број предмета', key: 'subjectId', sortable: true },
                { label: 'Датум доношења', key: 'timestamp', sortable: true },
                { label: 'Ближе одређење материје / назив', key: 'name', sortable: true },
                { label: 'Начин објављивања', key: 'issuer', sortable: true },
                { label: 'Број и страна', key: 'issuePage', sortable: true },

            ],


            emitedDateFromVal: null,
            emitedDateToVal: null,
            srCYRL: srCYRL,

            baseDIApiUrl:window.env.VUE_APP_API_DI_DEV,
            baseSPApiUrl: window.env.VUE_APP_API_SP_DEV,
             

            resultSize: null,
            result: [],

            contentType: -1,
            contentSubtype: -1,
            court: -1,
            department: -1,
            book: -1,
            bilten: -1,
            legalAreaId: -1,
            legalSubjectId: -1,
            legalSubsubjectId: -1,
            publishingMethod: -1,

            actId: null,
            titleQuery: null,
            bodyQuery: null,
            essRule: null,
            articles: null,
            relLaw: null,
            dateFrom: null,
            dateTo: null,

            site: '*',
            year: '*',
            issue: '*',

            resultLimit: 50,

            // Collections
            courtTypes: [],
            courts: [],
            departments: [],
            contentTypes: [],
            contentSubtypes: [],
            legalAreas: [],
            legalSubjects: [],
            legalSubsubjects: [],
            publishingMethods: [],
            books: [],
            biltens: [],
            sites: [],
            years: [],
            issues: [],
            resultLimitOptions: [],

            contentTypeQueries: [],
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        SupaBaseHeaderSec,
        SupaAdvancedSearchBaseHeaderSec,
        // Datepicker,
        // SortedTable,
        // SortLink,
        ResultCounter,
        DataPickerMaskComponent
    },
    computed: {
        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('SP')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
        canCopyQuery() {
            if (this.userInfoState && this.searchResult !== null) {
                return this.userInfoState.roles.includes('INTERNAL_USER');
            } return false;
        },
        disabledDatesFrom: function () {
            if (this.dateTo === null) {
                return { from: new Date }
            } else return { from: this.dateTo }
        },
        disabledDatesTo: function () {
            if (this.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.dateFrom, from: new Date }
        }
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        emitedDateFrom(e) {
            this.emitedDateFromVal = e;
        },
        emitedDateTo(e) {
            this.emitedDateToVal = e;
        },
        fetchFilterData: function () {
            axios.get(this.baseSPApiUrl + 'prins/fcSearch/filter')
                .then(response => {
                    this.courts = response.data.courtTypes;
                    this.legalAreas = response.data.legalAreas;
                    this.legalSubjects = response.data.legalSubjects;
                    this.publishingMethods = response.data.publishingMethods;
                });
            axios.get(this.baseSPApiUrl + 'prins/sadrzi/3')
                .then(response => {
                    this.contentTypes = response.data;
                    for (var i = 1; i < this.contentTypes.length; i++) {
                        this.contentTypeQueries[this.contentTypes[i].k] = this.contentTypes[i].query;
                    }
                });
        },
        copyQuery() {
            var data = {
                bk: (this.bodyQuery == '') ? null : this.bodyQuery,
                tk: (this.titleQuery == '') ? null : this.titleQuery,
                opid: (this.contentType == 1) ? this.contentSubtype : -1,
                spid: (this.contentType == 0) ? this.contentSubtype : -1,
                limit: this.resultLimit,
                lega: this.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubsubjectId : null,
                bn: (this.publishingMethod == 1) ? (this.issue + '/' + this.year) : null,
                pm: this.publishingMethod,
                desc: (this.contentType == 1),
                other: (this.contentType == 3),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                d: (this.departments.length > 0) ? this.department : null,
                ct: -1,
                c: (this.courts.length > 0) ? this.court : null,
                essRule: (this.essRule == '') ? null : this.essRule,
                articles: (this.articles == '') ? null : this.articles,
                relLaw: (this.relLaw == '') ? null : this.relLaw,
                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,

                bt: this.bilten,
                pspid: this.contentSubtype,
                act: (this.actId == '') ? null : this.actId,
            };

            var el = document.createElement('textarea');
            el.value = JSON.stringify({
                path: 'api/supa/fcSearch',
                payload: data
            });

            el.style.dislay = 'none';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            alert('Upit je kopiran u clipboard');
        },
        search: function () {
            // // Local DATA
            // let responseLocal = {"limit":50,"resultSize":392,"result":[{"htmlUuid":"f7cdcf02-281b-015f-1ed3-2761272ab869","courtName":"Европски суд за људска права","subjectId":"Представке бр. 10921/16, 28653/16, 34867/16, 54956/16 - Станивуковић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције у радном спору","issuer":"Службени гласник РС","issuePage":"098/2018-054","date":"27.11.2018","year":null},{"htmlUuid":"445bafef-73bd-e3cc-b052-6fd77f4cb37b","courtName":"Европски суд за људска права","subjectId":"Представке бр. 50117/13, 50776/13, 60349/13, 62038/13, 63099/13, 64201/13, 68381/13 - Мијатовић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције - постојање статуса жртве и одговарајуће обештећење за претрпљене повреде","issuer":null,"issuePage":null,"date":"23.10.2018","year":null},{"htmlUuid":"25732f71-b463-f17f-b72a-e8a954f737d4","courtName":"Европски суд за људска права","subjectId":"Представка број 26739/16 - Илић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције у парничном поступку вођеном по захтеву за накнаду штете","issuer":"Службени гласник РС","issuePage":"090/2018-037","date":"23.10.2018","year":null},{"htmlUuid":"b9cf26b6-7b87-6dc4-c3e0-08bec826bf7d","courtName":"Европски суд за људска права","subjectId":"Представка број 41820/16 - Љајић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције - неизвршавање правноснажнe пресудe донетe против друштвеног предузећа","issuer":"Службени гласник РС","issuePage":"091/2018-083","date":"23.10.2018","year":null},{"htmlUuid":"4e5898b3-ef61-927b-884c-89e1daee327b","courtName":"Европски суд за људска права","subjectId":"Представке бр. 54787/16, 55000/16, 55009/16, 55034/16, 55203/16, 58557/16, 60159/16 - Кнежевић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције - неизвршавање правноснажних пресуда донетих против друштвеног предузећа","issuer":"Службени гласник РС","issuePage":"082/2018-008","date":"09.10.2018","year":null},{"htmlUuid":"861eb848-e902-84e1-1a15-e59172ba4024","courtName":"Европски суд за људска права","subjectId":"Представка брoj 50586/07 - Добрила Богићевић Ристић против Србије","name":"Одбацивање представке због злоупотребе права на представку","issuer":"Службени гласник РС","issuePage":"090/2018-034","date":"02.10.2018","year":null},{"htmlUuid":"23e98d72-9b5d-05e7-89da-d7d8d0496e96","courtName":"Европски суд за људска права","subjectId":"Представке бр. 11362/17, 11366/17, 11387/17, 11481/17, 58011/17, 58021/17, 59990/17, 68618/17, 71798/17, 71930/17 - Михајловић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције и права на мирно уживање имовине из члана 1. Протокола 1. Конвенције - неизвршење или одложено извршење одлука усвојених против друштвених / државних предузећа на домаћем нивоу","issuer":"Службени гласник РС","issuePage":"075/2019-035","date":"03.10.2019","year":null},{"htmlUuid":"d3dd1607-2c29-217e-b54a-34a6dec49c3b","courtName":"Европски суд за људска права","subjectId":"Представке бр. 70716/16 и 4125/17 - Стојановић против Србије и Миленовић против Србије","name":"Проглашење представки неприхватљивим у смислу члана 35. ст. 1. и 4. Конвенције због неисцрпљивања домаћих правних средстава","issuer":"Службени гласник РС","issuePage":"083/2019-020","date":"12.09.2019","year":null},{"htmlUuid":"912bc6bf-40a7-edb9-ac22-58bff0f0eb25","courtName":"Европски суд за људска права","subjectId":"Представка број 7736/17 - Попов против Србије","name":"Проглашење представке неприхватљивом у смислу члана 35. ст. 3(а) и 4. Конвенције - очигледно неоснована представка","issuer":"Службени гласник РС","issuePage":"080/2019-171","date":"29.08.2019","year":null},{"htmlUuid":"37c76b62-93d6-8f1f-a82b-ee1a264c1e24","courtName":"Европски суд за људска права","subjectId":"Представке бр. 43815/17, 43819/17, 46335/17, 46382/17, 58825/17, 72892/17, 77141/17, 77875/17, 77876/17, 77879/17, 77882/17, 78142/17, 79575/17, 83186/17, 5791/18, 6256/18 – Стевановић и други против Србије","name":"Повреда права на правично суђење из члана 6. став 1. Конвенције и права на мирно уживање имовине из члана 1. Протокола 1. Конвенције - постојање статуса жртве подносилаца представки када износи досуђени према националном систему накнада не представљају одговарајуће обештећење за претрпљене повреде","issuer":"Службени гласник РС","issuePage":"067/2019-054","date":"27.08.2019","year":null},{"htmlUuid":"39f5100a-c4b9-4c6e-c4d5-2b37d9a82868","courtName":"Европски суд за људска права","subjectId":"Представка број 45727/16 и 51 других - Костић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције и права на мирно уживање имовине из члана 1. Протокола 1. Конвенције - неизвршење или одложено извршење одлука усвојених против друштвених / државних предузећа на домаћем нивоу","issuer":"Службени гласник РС","issuePage":"075/2019-027","date":"03.10.2019","year":null},{"htmlUuid":"a1735f57-c972-e2ca-7fe9-d0432fcacf92","courtName":"Европски суд за људска права","subjectId":"Представка број 60162/16 и 27 других - Голић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције - неизвршење или одложено извршење одлука усвојених против друштвених / државних предузећа на домаћем нивоу","issuer":"Службени гласник РС","issuePage":"075/2019-038","date":"03.10.2019","year":null},{"htmlUuid":"73d56ec9-56f3-2308-e514-d77529d473fa","courtName":"Европски суд за људска права","subjectId":"Представке бр. 29171/16, 29923/16, 29924/16, 30007/16, 30315/16, 31885/16, 60667/16, 60792/16, 7795/17 – Живановић и други против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерне дужине трајања радних спорова","issuer":"Службени гласник РС","issuePage":"074/2019-070","date":"19.09.2019","year":null},{"htmlUuid":"f4a247fa-a608-088d-4b91-2eee0931bd28","courtName":"Европски суд за људска права","subjectId":"Представка број 17148/16 - Родић и Свирчев против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерне дужине трајања парничног поступка","issuer":"Службени гласник РС","issuePage":"074/2019-064","date":"19.09.2019","year":null},{"htmlUuid":"13778c3b-72af-a4a9-bcca-14051be12432","courtName":"Европски суд за људска права","subjectId":"Представке бр. 31901/16, 41532/16, 42152/16, 43869/16, 8125/17, 12385/17 - Окиљ и други против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерне дужине трајања парничних поступака","issuer":"Службени гласник РС","issuePage":"074/2019-062","date":"19.09.2019","year":null},{"htmlUuid":"990457e1-5de4-ab02-a6c4-b3bfc43af917","courtName":"Европски суд за људска права","subjectId":"Представке бр. 32878/16, 79031/16, 4280/17, 4287/17 - Гопић против Србије и три друге представке","name":"Проглашење представки недопуштеним јер су поднете ван рока предвиђеног чланом 35. ст. 1. и 4. Конвенције, неблаговременост","issuer":"Службени гласник РС","issuePage":"083/2019-018","date":"12.09.2019","year":null},{"htmlUuid":"187a2fdf-5af7-2bcd-6f74-5d4d42e63c47","courtName":"Европски суд за људска права","subjectId":"Представка брoj 76024/16 - Лазић против Србије","name":"Проглашење представке неприхватљивом у складу са чланом 35. ст. 3(а) и 4. Конвенције због злоупотребе права на појединачну представку","issuer":"Службени гласник РС","issuePage":"080/2019-165","date":"29.08.2019","year":null},{"htmlUuid":"a04bf38f-1d28-37ab-e915-cc759ce6d5d0","courtName":"Европски суд за људска права","subjectId":"Представка број 64233/16 - Колашинац против Србије","name":"Проглашење представке неприхватљивом у смислу члана 35. ст. 1. и 4. Конвенције због неисцрпљивања домаћих правних средстава","issuer":"Службени гласник РС","issuePage":"080/2019-163","date":"29.08.2019","year":null},{"htmlUuid":"f799eac8-6b03-0036-609c-b9c3a7a12133","courtName":"Европски суд за људска права","subjectId":"Представке бр. 41404/16, 69284/16, 7135/17, 24979/17, 26621/17 - Максић против Србије и четири друге представке","name":"Проглашење представки неприхватљивим у смислу члана 35. ст. 1. и 4. Конвенције због неисцрпљивања домаћих правних средстава","issuer":"Службени гласник РС","issuePage":"080/2019-162","date":"29.08.2019","year":null},{"htmlUuid":"0bdbbe38-ab82-95d3-be6e-24c821e24bb5","courtName":"Европски суд за људска права","subjectId":"Представка број 41375/16 - Младеновић против Србије и две друге представке","name":"Проглашење представки неприхватљивим у складу са чланом 35. ст. 3(а) и 4. Конвенције због злоупотребе права на појединачну представку","issuer":"Службени гласник РС","issuePage":"079/2019-012","date":"29.08.2019","year":null},{"htmlUuid":"4fd1a243-520d-ae87-bd01-9ddc33b69acf","courtName":"Европски суд за људска права","subjectId":"Представка број 42144/16 - Антић против Србије","name":"Проглашење представке неприхватљивом у складу са чланом 35. ст. 3(а) и 4. Конвенције због злоупотребе права на појединачну представку","issuer":"Службени гласник РС","issuePage":"080/2019-169","date":"29.08.2019","year":null},{"htmlUuid":"69c6166c-8e83-b239-2d1c-81421e66ba0f","courtName":"Европски суд за људска права","subjectId":"Представка брoj 33470/16 - Бихорац против Србије","name":"Проглашење представке неприхватљивом у складу са чланом 35. ст. 3(а) и 4. Конвенције због злоупотребе права на појединачну представку","issuer":"Службени гласник РС","issuePage":"080/2019-167","date":"29.08.2019","year":null},{"htmlUuid":"be1af197-6430-c3a1-b4e4-c57be12148fc","courtName":"Европски суд за људска права","subjectId":"Представке бр. 64188/16 и 64190/16 - Хорватовић Василић против Србије и Хорватовић против Србије","name":"Проглашење представки неприхватљивим у смислу члана 35. ст. 3(а) и 4. Конвенције - очигледно неосноване представке","issuer":"Службени гласник РС","issuePage":"080/2019-160","date":"29.08.2019","year":null},{"htmlUuid":"77615dcf-f600-d943-44a9-2f1d7514e176","courtName":"Европски суд за људска права","subjectId":"Представка број 22640/16 - Стојковић Србије","name":"Проглашење представке неприхватљивом у смислу члана 35. ст. 3(а) и 4. Конвенције - очигледно неоснована представка","issuer":"Службени гласник РС","issuePage":"079/2019-014","date":"29.08.2019","year":null},{"htmlUuid":"260ec652-8fa8-ac5f-14b0-b0027ccbfa03","courtName":"Европски суд за људска права","subjectId":"Представке бр. 55003/16, 55165/16, 55199/16, 58368/16, 14938/17, 20906/17, 22606/17, 25312/17, 61028/17, 61340/17, 77837/17, 77858/17 - Радовановић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције - постојање статуса жртве подносилаца представки када износи досуђени према националном систему накнада не представљају одговарајуће обештећење за претрпљене повреде","issuer":"Службени гласник РС","issuePage":"067/2019-060","date":"27.08.2019","year":null},{"htmlUuid":"c79c516f-0b3b-6bb6-a5fe-ad35ae362366","courtName":"Европски суд за људска права","subjectId":"Представка број 38133/16 - Љиљана Пушкић против Србије","name":"Проглашење представке неприхватљивом у смислу члана 35. ст. 1. и 4. Конвенције због неисцрпљивања домаћих правних средстава","issuer":"Службени гласник РС","issuePage":"059/2019-034","date":"20.06.2019","year":null},{"htmlUuid":"4de5bbad-f237-e464-bcdb-cb5c4f45a032","courtName":"Европски суд за људска права","subjectId":"Представка број 78886/16 - Дејан Живојиновић против Србије","name":"Одбацивање представке као очигледно неосноване - непостојање прекомерене дужине трајања поступка","issuer":"Службени гласник РС","issuePage":"030/2019-058","date":"26.02.2019","year":null},{"htmlUuid":"47244f3d-686b-5f40-7d76-205a68ad455f","courtName":"Европски суд за људска права","subjectId":"Представка број 51112/16 - ПТП Спин Комерц д.о.о. против Србије","name":"Проглашење представке неприхватљивом због непостојања положаја \"жртве\" у смислу члана 34. Конвенције","issuer":"Службени гласник РС","issuePage":"030/2019-060","date":"26.02.2019","year":null},{"htmlUuid":"9869fd11-012a-182a-9a1d-da00f894fabe","courtName":"Европски суд за људска права","subjectId":"Представка број 1128/16 - Гјини против Србије","name":"Повреда материјалног и процесног аспекта забране мучења из члана 3. Конвенције - злостављање подносиоца представке од стране затвореника током боравка у притвору и неспровођење истаге о злостављању","issuer":"Службени гласник РС","issuePage":"015/2019-105","date":"15.01.2019","year":null},{"htmlUuid":"35d0ce29-5518-6c8b-6181-f187c3547e4c","courtName":"Европски суд за људска права","subjectId":"Представка број 34929/16 - Музафера Бихорац Хајдарагић против Србије","name":"Одбацивање представке због злоупотребе права на представку","issuer":"Службени гласник РС","issuePage":"103/2018-085","date":"06.11.2018","year":null},{"htmlUuid":"188b25d3-fa51-ef78-3555-670ebaf06185","courtName":"Европски суд за људска права","subjectId":"Представка брoj 64232/16 - Гордана Нишевић Тадић против Србије","name":"Проглашење представке недопуштеном због злоупотребе права на појединачну представку","issuer":"Службени гласник РС","issuePage":"086/2018-083","date":"24.09.2018","year":null},{"htmlUuid":"668cabf4-4f12-1ece-eef7-93bd26689c17","courtName":"Европски суд за људска права","subjectId":"Представка брoj 33104/16 - Миодраг Матовић против Србије","name":"Одбацивање представке због злоупотребе права на представку","issuer":"Службени гласник РС","issuePage":"086/2018-085","date":"24.09.2018","year":null},{"htmlUuid":"8e382e16-5b0c-5910-7192-bd98f9a33dbc","courtName":"Европски суд за људска права","subjectId":"Представкe бр. 54001/15, 55113/15, 60075/15, 7193/16 - Шаћировић и други против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерене дужине трајања парничних поступака","issuer":"Службени гласник РС","issuePage":"024/2018-107","date":"20.02.2018","year":null},{"htmlUuid":"a9d15ceb-aee9-9fc1-f729-5b892610ee20","courtName":"Европски суд за људска права","subjectId":"Представкe бр. 8647/16, 12666/16, 20851/16 - Хрустић и други против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерене дужине трајања парничних и управних поступака","issuer":"Службени гласник РС","issuePage":"007/2018-056","date":"09.01.2018","year":null},{"htmlUuid":"05d23cea-bee6-0f91-0b87-f05fbafbe00d","courtName":"Европски суд за људска права","subjectId":"Представка број 19222/16 - Миловановић против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерене дужине трајања поступка - постојање статуса жртве подносиоца представке када износ досуђени према националном систему накнада не представља одговарајуће обештећење за претрпљене повреде","issuer":"Службени гласник РС","issuePage":"010/2018-025","date":"19.12.2017","year":null},{"htmlUuid":"f5277144-bc25-8d70-7a1b-1cc07dfb7460","courtName":"Европски суд за људска права","subjectId":"Представке број 2866/16, 6789/16, 13143/16 - Батић и други против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције и права на мирно уживање имовине из члана 1. Протокола 1. Конвенције - неизвршавање правноснажних пресуда донетих против друштвених предузећа","issuer":"Службени гласник РС","issuePage":"108/2017-059","date":"17.10.2017","year":null},{"htmlUuid":"20c65bd6-957d-e129-70a5-8f039fba8e98","courtName":"Европски суд за људска права","subjectId":"Представка број 21388/15 - Алмаши против Србије","name":"Повреда процесног аспекта забране мучења из члана 3. Конвенције због неспровођења ефикасне званичне истраге о наводима подносиоца представке у вези са злостављњем од стране полиције","issuer":"Службени гласник РС","issuePage":"083/2019-048","date":"08.10.2019","year":null},{"htmlUuid":"bd32eecd-382c-7c07-170d-f62851fef9b8","courtName":"Европски суд за људска права","subjectId":"Представка број 65474/16 - Јовичић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције и права на мирно уживање имовине из члана 1. Протокола 1. Конвенције - неизвршење или одложено извршење одлука усвојених против друштвених / државних предузећа на домаћем нивоу","issuer":"Службени гласник РС","issuePage":"074/2019-076","date":"19.09.2019","year":null},{"htmlUuid":"ee582d4a-19f7-0c9f-c6a8-6f3a2d7b7880","courtName":"Европски суд за људска права","subjectId":"Представка број 14074/15 - Мартиновић против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерне дужине трајања парничног поступка","issuer":"Службени гласник РС","issuePage":"074/2019-074","date":"19.09.2019","year":null},{"htmlUuid":"44e81ec9-4a8d-e040-471c-fd16a0db3a10","courtName":"Европски суд за људска права","subjectId":"Представка број 7129/15 - Синђелић и други против Србије","name":"Проглашење представке неприхватљивом због непостојања положаја жртве у смислу члана 34. Конвенције","issuer":"Службени гласник РС","issuePage":"079/2019-005","date":"29.08.2019","year":null},{"htmlUuid":"07a47037-a8da-3bfb-d0e7-bb13f5932a06","courtName":"Европски суд за људска права","subjectId":"Представка број 53056/15 - Владимиров против Србије","name":"Проглашење представке неприхватљивом због непостојања положаја жртве у смислу члана 34. Конвенције","issuer":"Службени гласник РС","issuePage":"067/2019-053","date":"09.07.2019","year":null},{"htmlUuid":"c154eb86-784a-9ad7-7ecc-6fa4bd5f532f","courtName":"Европски суд за људска права","subjectId":"Представка број 30670/15 - Љубомир Бркић против Србије","name":"Проглашење представке неприхватљивом због непостојања положаја \"жртве\" у смислу члана 34. Конвенције","issuer":"Службени гласник РС","issuePage":"061/2019-055","date":"20.06.2019","year":null},{"htmlUuid":"188e8dbe-d931-a906-dc82-d7d473120922","courtName":"Европски суд за људска права","subjectId":"Представка број 16019/15 - Окиљ против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерене дужине трајања парничних поступака","issuer":"Службени гласник РС","issuePage":"050/2019-123","date":"28.05.2019","year":null},{"htmlUuid":"c1596210-9f8a-e84e-65e2-fc6a82c08b1e","courtName":"Европски суд за људска права","subjectId":"Представка број 41392/15 - Николић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције у парничном поступку вођеном по захтеву за накнаду штете","issuer":"Службени гласник РС","issuePage":"027/2019-132","date":"19.03.2019","year":null},{"htmlUuid":"a4a63e96-8e72-4741-5c48-c1ca5e2cc734","courtName":"Европски суд за људска права","subjectId":"Представка број 24899/15 - Стојковић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције због прекомереног трајања управног поступка","issuer":"Службени гласник РС","issuePage":"014/2019-233","date":"22.01.2019","year":null},{"htmlUuid":"c1356cc0-25c1-b5fa-9800-db643beb231e","courtName":"Европски суд за људска права","subjectId":"Представка број 16796/15 - Ћорић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције - постојање статуса жртве подностељке представке и одговарајуће обештећење за претрпљене повреде","issuer":"Службени гласник РС","issuePage":"080/2018-035","date":"25.09.2018","year":null},{"htmlUuid":"be03d52b-34d3-2e8d-d6f6-051b06c076d7","courtName":"Европски суд за људска права","subjectId":"Представке бр. 27471/15, 27288/15, 27751/15, 27779/15, 27790/15, 28156/15, 28418/15, 30893/15, 30906/15, 32933/15, 35780/15, 40646/15, 55066/15 - Мирковић и други против Србије","name":"Повреда права на правично суђење из члана 6. став 1. Конвенције због неуједначености судске праксе, односно постојања \"дубоких и дуготрајних разлике\" у судској пракси домаћих судова","issuer":"Службени гласник РС","issuePage":"096/2018-218","date":"26.06.2018","year":null},{"htmlUuid":"eb46e654-56d6-639b-c49e-519e5ab25aaf","courtName":"Европски суд за људска права","subjectId":"Представка број 54770/15 - Максовић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције и права на мирно уживање имовине из члана 1. Протокола 1. Конвенције - неизвршавање правноснажних пресуда донетих против друштвених предузећа","issuer":"Службени гласник РС","issuePage":"104/2017-142","date":"17.10.2017","year":null},{"htmlUuid":"fb350b54-b79e-a372-8b5c-a0fa038724d4","courtName":"Европски суд за људска права","subjectId":"Представка број 24923/15 - Билић против Србије","name":"Повреда права на суђење у разумном року из члана 6. став 1. Конвенције и права на мирно уживање имовине из члана 1. Протокола 1. Конвенције - неизвршавање правноснажних пресуда донетих против друштвених предузећа, одлука Уставног суда и статус жртве","issuer":"Службени гласник РС","issuePage":"104/2017-137","date":"17.10.2017","year":null},{"htmlUuid":"10db6152-27a1-0051-ded7-f0e8352e0d96","courtName":"Европски суд за људска права","subjectId":"Представка број 26308/15 - Стокић против Србије","name":"Повреде права на правично суђење из члана 6. став 1. Конвенције због прекомерене дужине радног спора","issuer":"Службени гласник РС","issuePage":"104/2017-140","date":"17.10.2017","year":null}]};
            // this.result = responseLocal.result;
            // this.resultSize = responseLocal.resultSize;
            // for (var i = 0; i < this.result.length; i++) {
            //     this.result[i].timestamp = moment(this.result[i].date, 'DD.MM.YYYY').valueOf();
            // }


            const vm = this;
            var data = {
                bk: (this.bodyQuery == '') ? null : this.bodyQuery,
                tk: (this.titleQuery == '') ? null : this.titleQuery,
                opid: (this.contentType == 1) ? this.contentSubtype : -1,
                spid: (this.contentType == 0) ? this.contentSubtype : -1,
                limit: this.resultLimit,
                lega: this.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubsubjectId : null,
                bn: (this.publishingMethod == 1) ? (this.issue + '/' + this.year) : null,
                pm: this.publishingMethod,
                desc: (this.contentType == 1),
                other: (this.contentType == 3),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                d: (this.departments.length > 0) ? this.department : null,
                ct: -1,
                c: (this.courts.length > 0) ? this.court : null,
                essRule: (this.essRule == '') ? null : this.essRule,
                articles: (this.articles == '') ? null : this.articles,
                relLaw: (this.relLaw == '') ? null : this.relLaw,
                // df: this.dateFrom,
                // dt: this.dateTo,
                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,

                bt: this.bilten,
                pspid: this.contentSubtype,
                act: (this.actId == '') ? null : this.actId,
            };

            //added velja and aleksandar
            if (this.publishingMethod == -1) {
                data.bt = this.bilten;
            }
            // publisheMethod Начин објављивања
            if (this.publishingMethod == 3) {
                data.bt = this.book;
            }

            if (this.publishingMethod == 4) {
                data.bn = this.site;
            }

            axios.post(this.baseDIApiUrl + 'sp/advancedSearchFC', data)
                .then(response => {
                    var data = response.data.result;

                    for (var i = 0; i < data.length; i++) {
                        data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                    }

                    this.result = data;
                    this.resultSize = response.data.resultSize;
                    this.limit = response.data.limit;
                }).catch(function (error) {
                    console.log(error);
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                });
        },
        onReset: function () {
            this.contentType = -1;
            this.contentSubtype = -1;
            this.court = -1;
            this.department = -1;
            this.book = -1;
            this.bilten = -1;
            this.legalAreaId = -1;
            this.legalSubjectId = -1;
            this.legalSubsubjectId = -1;
            this.publishingMethod = -1;

            this.actId = null;
            this.titleQuery = null;
            this.bodyQuery = null;
            this.essRule = null;
            this.articles = null;
            this.relLaw = null;
            this.dateFrom = null;
            this.dateTo = null;

            this.emitedDateFromVal = null;
            this.emitedDateToVal = null;

            this.site = '*';
            this.year = '*';
            this.issue = '*';

            this.resultLimit = 50;
            this.result = [];
            this.resultSize = null;
            this.$refs.dataPickerMask.resetDate();
        }
    },
    watch: {
        contentType: function () {
            this.contentSubtype = -1;

            if (this.contentType > -1  && this.contentType != 3) {
                var query = this.contentTypeQueries[this.contentType];
                axios.get(this.baseSPApiUrl + 'prins/3/contentSubtype?obrazlozenje=' + (query.obrazlozenje ? 'true' : 'false')
                    + '&sentenca=' + (query.sentenca ? 'true' : 'false')
                    + '&pravniStav=' + (query.pravniStav ? 'true' : 'false'))
                    .then(response => {
                        this.contentSubtypes = response.data;
                    });
            } else {
                this.contentSubtypes = [];
            }
        },
        court: function () {
            this.department = -1;
            if (this.court > -1) {
                axios.get(this.baseSPApiUrl + 'prins/departments/3/' + this.court)
                    .then(response => { this.departments = response.data });
            } else {
                this.departments = [];
            }
        },
        legalSubjectId: function () {
            this.legalSubsubjectId = -1;
            if (this.legalSubjectId > -1) {
                axios.get(this.baseSPApiUrl + 'prins/legalSubSubject/3/' + this.legalSubjectId)
                    .then(response => { this.legalSubsubjects = response.data })
            } else {
                this.legalSubsubjects = [];
            }
        },
        publishingMethod: function () {
            this.years = [];
            this.issues = [];
            this.sites = [];
            this.biltens = [];
            this.books = [];

            this.year = '*';
            this.issue = '*';
            this.bilten = -1;
            this.book = -1;
            this.site = '*';

            if (this.publishingMethod == 1) {
                axios.get(this.baseSPApiUrl + 'prins/gazette/years/3')
                    .then(response => {
                        this.years = response.data;
                    })
            } else if (this.publishingMethod == 2) {
                axios.get(this.baseSPApiUrl + 'prins/bilteni/3')
                    .then(response => {
                        this.biltens = response.data;
                    })
            } else if (this.publishingMethod == 3) {
                axios.get(this.baseSPApiUrl + 'prins/books/3')
                    .then(response => {
                        this.books = response.data;
                    })
            } else if (this.publishingMethod == 4) {
                axios.get(this.baseSPApiUrl + 'prins/websites/3')
                    .then(response => {
                        this.sites = response.data;
                    })
            }
        },
        year: function () {
            this.issue = '*';
            if (this.year !== '*') {
                axios.get(this.baseSPApiUrl + 'prins/gazette/numbers/3/' + this.year)
                    .then(response => {
                        this.issues = response.data;
                    })
            } else {
                this.issues = [];
            }
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_supa';
    },
    mounted() {
        this.fetchFilterData();
    },
}
</script>

<style >
.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 35%;
}

.table-bootstrap-vue thead tr th:nth-child(5) {
    width: 25%;
}

.table-bootstrap-vue thead tr th:nth-child(6) {
    width: 10%;
}
</style>
